const KazakhstanSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_111682)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#338AF3"
      />
      <path
        d="M31.3046 20.2168H8.6958C8.6958 21.7777 10.0553 23.0429 11.616 23.0429H11.5219C11.5219 24.6038 12.7871 25.869 14.348 25.869C14.348 27.4298 15.6132 28.6951 17.1741 28.6951H22.8263C24.3871 28.6951 25.6524 27.4298 25.6524 25.869C27.2132 25.869 28.4785 24.6038 28.4785 23.0429H28.3844C29.9449 23.0429 31.3046 21.7777 31.3046 20.2168Z"
        fill="#FFDA44"
      />
      <path
        d="M27.8265 16.5215C27.8265 20.8437 24.3226 24.3476 20.0004 24.3476C15.6781 24.3476 12.1743 20.8437 12.1743 16.5215"
        fill="#338AF3"
      />
      <path
        d="M25.9779 16.5214L23.5354 17.6704L24.8361 20.0361L22.1837 19.5286L21.8476 22.208L20.0002 20.2373L18.1527 22.208L17.8167 19.5286L15.1643 20.0359L16.465 17.6704L14.0225 16.5214L16.465 15.3725L15.1643 13.007L17.8166 13.5143L18.1528 10.835L20.0002 12.8057L21.8477 10.835L22.1837 13.5143L24.8361 13.007L23.5354 15.3726L25.9779 16.5214Z"
        fill="#FFDA44"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_111682">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default KazakhstanSvg;
